import { h } from 'preact'
import InputGroup from '../ui-components/InputGroup'

export interface SSIFooterData {
  url: string
}

interface Props extends SSIFooterData {
  onChange: (data: SSIFooterData) => void
}

const SSIFooter = ({ url, onChange }: Props) => {
  return (
    <InputGroup
      title='SSI URL'
      type='text'
      onChange={(e: ChangeEvent) => onChange({ url: e.target.value })}
      value={url} />
  )
}

export default SSIFooter
